import React, { useCallback, useMemo, useState } from 'react'
import isHotkey from 'is-hotkey'

import { withReact, Slate } from 'slate-react'
import { createEditor } from 'slate'
import { withHistory } from 'slate-history'
import { IconMaps } from '@ow/icons'
import { serializeToHtml, serializeToText, toggleMark } from './utils/util'
import { HOTKEYS } from './utils/hotkey'
import MarkButton from './components/MarkButton'
import BlockButton from './components/BlockButton'
import MarkElement from './components/MarkElement'
import BlockElement from './components/BlockElement'
import {
  StyledRichTextEditorContainer,
  StyledRichTextEditor,
  StyledRichTextToolbar,
} from './styled'
import ColorPicker from '../color-picker'
import Tooltip from '../tooltip'
import FontLineHeight from './components/FontLineHeight'

const RichTextEditor = ({
  onChange,
  uploadImg,
  value = [
    {
      type: 'paragraph',
      children: [{ text: '' }],
    },
  ],
  placeholder = '请输入内容',
}) => {
  const renderElement = useCallback((props) => <BlockElement {...props} />, [])
  const renderLeaf = useCallback((props) => <MarkElement {...props} />, [])
  const editor = useMemo(() => withHistory(withReact(createEditor())), [])
  const [isShowColorPicker, setShowColorPicker] = useState(false)

  // 编辑器change事件
  const editorChange = (e) => {
    const htmlVal = e.map((m) => {
      return serializeToHtml(m)
    })
    const textVal = serializeToText(e)
    onChange({ htmlVal: htmlVal.join(''), textVal, selfVal: e })
  }

  return (
    <StyledRichTextEditorContainer>
      <Slate editor={editor} value={value} onChange={(e) => editorChange(e)}>
        <StyledRichTextToolbar>
          <MarkButton format="bold" icon="fontBold" tip="加粗" />
          <MarkButton format="italic" icon="fontItalic" tip="斜体" />
          <MarkButton format="underline" icon="fontUderline" tip="下划线" />
          {/* <MarkButton format="code" icon="fontCode" tip="代码" /> */}
          {/* <MarkButton format="color" icon="fontColor" /> */}
          <Tooltip
            className="bg-primary-50"
            trigger={
              <span className="relative">
                <span
                  onClick={(e) => {
                    e.preventDefault()
                    setShowColorPicker(!isShowColorPicker)
                  }}
                >
                  <IconMaps
                    type="fontColor"
                    width={18}
                    height={18}
                    fill="dark"
                  />
                </span>
                {isShowColorPicker && (
                  <ColorPicker
                    onChange={(e) => {
                      toggleMark(editor, 'color', e)
                    }}
                    setShowColorPicker={setShowColorPicker}
                  />
                )}
              </span>
            }
            position="bottom"
            on={['hover']}
          >
            <span>文字颜色</span>
          </Tooltip>

          <BlockButton format="indent" icon="fontIndent" tip="缩进" />
          <BlockButton format="heading-one" icon="fontH1" tip="一级标题" />
          <BlockButton format="heading-two" icon="fontH2" tip="二级标题" />
          <BlockButton format="block-quote" icon="fontQuote" tip="引用" />
          <BlockButton
            format="numbered-list"
            icon="fontOrderList"
            tip="有序列表"
          />
          <BlockButton
            format="bulleted-list"
            icon="fontBulletList"
            tip="无序列表"
          />
          <BlockButton format="left" icon="fontLeft" tip="左对齐" />
          <BlockButton format="center" icon="fontCenter" tip="居中" />
          <BlockButton format="right" icon="fontRight" tip="右对齐" />
          <BlockButton format="justify" icon="fontJustify" tip="两边对齐" />
          <BlockButton
            format="image"
            icon="image"
            tip="图片"
            uploadImg={uploadImg}
          />
          <FontLineHeight editor={editor} />
        </StyledRichTextToolbar>
        <StyledRichTextEditor
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          placeholder={placeholder}
          spellCheck
          autoFocus
          onKeyDown={(event) => {
            Object.keys(HOTKEYS).forEach((hotkey) => {
              if (isHotkey(hotkey, event)) {
                event.preventDefault()
                const mark = HOTKEYS[hotkey]
                toggleMark(editor, mark)
              }
            })
          }}
        />
      </Slate>
    </StyledRichTextEditorContainer>
  )
}

export default RichTextEditor
